import { render, staticRenderFns } from "./ProductProperty.vue?vue&type=template&id=dcf9e244&"
import script from "./ProductProperty.vue?vue&type=script&lang=ts&"
export * from "./ProductProperty.vue?vue&type=script&lang=ts&"
import style0 from "./ProductProperty.vue?vue&type=style&index=0&id=dcf9e244&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports